import styles from './ServiceAndMaintenance.module.scss';
import Hero from './Hero/ServiceAndMaintenanceHero';
import BookService from './BookService/ServiceAndMaintenanceBookService';
import ServiceAppointment from './ServiceAppointment/ServiceAppointment';

const ServiceAndMaintenance = ({ fields }) => {
  // 安全的字段提取函数
  const getFieldValue = (field) => {
    if (field?.value !== undefined) {
      return field.value;
    }
    return typeof field === 'string' ? field : '';
  };

  // 从Sitecore数据中提取各个部分的数据，支持两种数据格式
  const heroSectionData = {
    title: getFieldValue(fields?.heroText),
    image: fields?.heroImage,
  };

  const bookServiceData = {
    title: getFieldValue(fields?.bookTitle),
    text: getFieldValue(fields?.bookText),
    buttonText: getFieldValue(fields?.bookButtonText),
    buttonUrl: fields?.bookButtonUrl?.value?.href || getFieldValue(fields?.bookButtonUrl),
    image: fields?.bookImage,
  };

  const serviceAppointmentData = {
    title: getFieldValue(fields?.stepTitle),
    steps: fields?.stepList || [],
  };

  return (
    <div className={styles.wrapper}>
      <Hero heroSectionData={heroSectionData} />
      <BookService bookServiceData={bookServiceData} />
      {/* <ServiceAppointment serviceAppointmentData={serviceAppointmentData} /> */}
    </div>
  );
};

export default ServiceAndMaintenance;
